import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete } from '@mui/material';
import InputBase from '@mui/material/InputBase';
import { alpha, styled } from '@mui/material/styles';
import { AppModels } from 'cdx-common';
import { useNavigate } from 'react-router-dom';
import { SuperSearchInput } from './SuperSearchInput';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    maxWidth: 300,
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}));

export const CenteredSearch = () => {
    const navigate = useNavigate();
    const onItemSelected = <T extends BaseAttrs>(type: AppModels, id: ModelId, data: T) => {
        console.log('item selected', data);
        switch (type) {
            case AppModels.users:
                navigate('/user/' + id);
                break;
            case AppModels.contacts:
                navigate('/contact/' + id);
                break;
            case AppModels.projects:
                navigate('/project/' + id);
                break;
            case AppModels.companies:
                navigate('/company/' + id);
                break;
            default:
                break;
        }
    };

    return <div style={{ minWidth: 0, width: '100%' }}>
        <div style={{ margin: '0 auto', maxWidth: 300, width: '100%' }}>
            <SuperSearchInput clearOnSelect onItemSelected={onItemSelected} textfieldProps={{ size: 'small', placeholder: 'Accès rapide ...', label: null }} />
        </div>
    </div>;
};

export const OldCenteredSearch = () => {

    return <div style={{ position: 'absolute', top: 15, left: 0, width: '100%' }}>
        <div style={{ margin: '0 auto', width: 300 }}><Search>
            <SearchIconWrapper>
                <SearchIcon />
            </SearchIconWrapper>
            <Autocomplete
                options={[]}
                renderInput={(params) => <StyledInputBase placeholder="Rechercher…" inputProps={{ ...params, 'aria-label': 'search' }}
                />} />
        </Search></div>
    </div>;
};
